import $ from 'jquery'
import trumbowyg from 'trumbowyg'

function init() {
    setUpTrumbowyg()
}

function setUpTrumbowyg() {
    $('textarea.froala').each((index, textarea) => {
        textarea = $(textarea)

        const id = textarea.attr('id')
        const placeholder = textarea.attr('placeholder')

        $(`#${id}`).trumbowyg({
            svgPath: '/trumbowyg-icons.svg'
        })
    })
}

export default { init }